export enum FetchStatus {
    IDLE,
    PENDING,
    FULFILLED,
    REJECTED,
}
